import {
  ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse,
  DrawerFooterArea,
  Drawer as DrawerType,
  MelcoModelsUserSerialNumber,
} from "melco-shared-logic";
import {
  Col,
  Drawer,
  FullWidthSpace,
  Row,
  Steps,
  DesignTokens,
} from "melco-ui";
import { useState } from "react";
//import { ChangeMachineLicensesSummary } from "../form/changelevel/ChangeMachineLicensesSummary";
//import { ChangeMachineLicensesVersionAndLevel } from "../form/changelevel/ChangeMachineLicensesVersionAndLevel";
import { useTranslation } from "react-i18next";
import { ChangeMachineLicensesForm, ChangeMachineLicensesFormValueType } from "../form/machinelicenses/change/ChangeMachineLicensesForm";
import { ChangeMachineLicensesChanges } from "../form/machinelicenses/change/ChangeMachineLicensesChanges";
import { ChangeMachineLicensesSummary } from "../form/machinelicenses/change/ChangeMachineLicensesSummary";
import { CopyChangeMachineLicenses } from "../form/machinelicenses/change/CopyChangeMachineLicenses";

const { spacings } = DesignTokens;

type ChangeMachineLicensesDrawerProps = {
  drawer: DrawerType;
};

export type NewSelectedValuesForLicenseChangeLevel = {
  //  new_version_id:string;
  new_subscription_code: string;
  //new_version_id_display_value: string;
  new_subscription_code_display_value: string;
  subscription_start_date?: Date | null;
  reduce_license_count?: number;
  new_sub_start_date?: Date | null;
};

export const ChangeMachineLicensesDrawer: React.FC<
  ChangeMachineLicensesDrawerProps
> = ({ drawer }) => {
  const { closeDrawer, isDrawerOpen } = drawer;
  const [currentStep, setCurrentStep] = useState(0);
  const [licenseFormValues, setLicenseFormValues] =
    useState<ChangeMachineLicensesFormValueType>();
  const [changeMachineLicensesResponse, setChangeMachineLicensesResponse] = useState<
    MelcoModelsUserSerialNumber | undefined
  >();
  const [currentLicense, setCurrentLicense] = useState<
    ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse | undefined
  >();
  const [newValuesToChangeLevel, setNewValuesToChangeLevel] =
    useState<NewSelectedValuesForLicenseChangeLevel>();

  const { t } = useTranslation();

  const onCloseDrawer = () => {
    setCurrentStep(0);
    setLicenseFormValues({

      transaction_id: "",
      email_address: "",
      language: "",

    })
    setNewValuesToChangeLevel({
      new_subscription_code: "",
      new_subscription_code_display_value: "",
      new_sub_start_date: null,
      reduce_license_count: 0,
      subscription_start_date: null
    })
    closeDrawer();
  };

  const onChangeMachineLicensesStep1CallBackFn = (
    values: ChangeMachineLicensesFormValueType,
    currentLicense: ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse | undefined
  ) => {
    setLicenseFormValues(values);
    setCurrentStep(currentStep + 1);
    setCurrentLicense(currentLicense);
  };

  const onChangeMachineLicensesStep2CallBackFn = (
    newValuesToChangeLevel: NewSelectedValuesForLicenseChangeLevel,
    currentLicense?: ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse | undefined
  ) => {
    setCurrentStep(currentStep + 1);

    setNewValuesToChangeLevel(newValuesToChangeLevel);
    setCurrentLicense(currentLicense);
  };

  const onChangeMachineLicensesStep3CallBackFn = (
    obj: ControlcenterMelcoControlCenterModelsUserMachineLicenseResponse | undefined
  ) => {
    setChangeMachineLicensesResponse(obj);
    setCurrentStep(currentStep + 1);
  };

  const stepback = () => {
    setCurrentStep(currentStep - 1);
  };

  const forms: any = [
    <ChangeMachineLicensesForm
      onChangeMachineLicensesCallBackFn={onChangeMachineLicensesStep1CallBackFn}
      licenseFormValues={licenseFormValues}
    />,

    <ChangeMachineLicensesChanges
      stepback={stepback}
      callbackFn={onChangeMachineLicensesStep2CallBackFn}
      currentLicense={currentLicense}
      newValuesToChangeLevel={newValuesToChangeLevel}
    />,

    // <ChangeMachineLicensesSummary
    //   stepback={stepback}
    //   callbackFn={onChangeMachineLicensesStep3CallBackFn}
    //   currentLicense={currentLicense}
    //   newValuesToChangeLevel={newValuesToChangeLevel}
    // />,
    <ChangeMachineLicensesSummary
      stepback={stepback}
      callbackFn={onChangeMachineLicensesStep3CallBackFn}
      machineLicensesFormValues={licenseFormValues}
      machineLicensesDisplayValues={newValuesToChangeLevel}
      currentLicense={currentLicense}
    />,
    <CopyChangeMachineLicenses
      successMessage={
        currentLicense?.master_user_name &&
          currentLicense.master_user_name !== ""
          ? t(
            "machinelicenses.change.message_change_two"
          ).replace("[email]", currentLicense?.master_user_name)
          : t("machinelicenses.change.message")
      }
      changeMachineLicensesResponse={changeMachineLicensesResponse}
      onCloseDrawer={onCloseDrawer}

      title={t("licensemanager.changelevel.copy.title")}
    />,
  ];

  // isDrawerOPen is used multiple times to display UI, basically to refresh DOM and build components in DOM again
  // As Footer section was becoming empty if go from one Drawer to other like Create Drawer, Upgrade Drawer, Change Level Drawer

  return (
    <>
      {" "}
      {isDrawerOpen && (
        <Drawer
          title={t("licensemanager.cards.changelicense.title")}
          placement="right"
          width={1000}
          closable={true}
          onClose={onCloseDrawer}
          open={isDrawerOpen}
          footer={isDrawerOpen && <DrawerFooterArea />}
        >
          <FullWidthSpace direction="vertical">
            <Steps
              items={[
                {
                  title: t("licensemanager.changelevel.steps.checklicense"),
                },

                { title: t("licensemanager.changelevel.steps.changes") },

                { title: t("licensemanager.changelevel.steps.summary") },
                {
                  title: t("licensemanager.changelevel.steps.copylicense"),
                },
              ]}
              current={currentStep}
              labelPlacement="vertical"
              size="small"
            />

            <FullWidthSpace direction="vertical" size="middle">
              {/* <Title level={4}>Define customer & currentLicense details</Title> */}

              <div>
                <Row gutter={[spacings.middle, 0]}>
                  <Col xs={24} md={24}>
                    {isDrawerOpen && forms[currentStep]}
                  </Col>
                </Row>
              </div>
            </FullWidthSpace>
          </FullWidthSpace>
        </Drawer>
      )}
    </>
  );
};
